import { gql } from '@apollo/client';

export const IMAGE_UPLOAD_LINK = gql`
  mutation imageUploadLink($filename: String!, $size: Int!, $token: String) {
    imageUploadLink(filename: $filename, size: $size, token: $token) {
      success
      uploadUrl
      fileName
    }
  }
`;
